// dependencies
import { fromJS } from "immutable";
import moment from "moment";

// utils
import SerializeObject from "../utils/SerializeObject";

const baseAction = "FEEDBACK";

export function GetFeedback(userId, view, params, page = 0) {
	return (dispatch) => {
		// setup initial params object
		const paramsObject = { offset: page * 10, view };

		// add additional parameters
		params.forEach((value, key) => {
			if (value === "") {
				return;
			}

			paramsObject[key] = value;
		});

		// generate the query string
		const queryString = SerializeObject(paramsObject);

		dispatch({ type: `${baseAction}:GETMANY`, userId, queryString, view });
	};
}

export function DeleteFeedback(feedbackId) {
	return async (dispatch) => {
		await dispatch({ type: `${baseAction}:DELETE`, feedbackId });
	};
}

export function ParseSingleFeedbackResponse(feedback) {
	return (dispatch) => {
		let feedbackObject = feedback;

		// collect user objects
		const userObjects = {
			[feedbackObject.author_object._id]: feedbackObject.author_object,
		};
		feedbackObject.subjects_list.forEach((u) => {
			userObjects[u._id] = u;
		});
		feedbackObject._userObjects = userObjects; // eslint-disable-line no-underscore-dangle

		// make immutable
		feedbackObject = fromJS(feedbackObject);

		// momentize the date
		feedbackObject = feedbackObject.set("last_updated", moment(feedbackObject.get("last_updated")));
		dispatch({ type: `${baseAction}:SET`, feedback: feedbackObject });
	};
}

export function ParseFeedbackResponse(response, userId, view) {
	return (dispatch) => {
		dispatch({
			type: `${baseAction}:PARSE_RESPONSE`,
			data: response,
			userId,
			view,
		});
	};
}
